module.exports = __webpack_public_path__ + "img/moishop_portfolio_3.292716e4.png";